// src/pages/dashboards/PartnerDashboard.jsx
// Partner layout. One page for now, but routed the same way as the other roles
// so it can grow without restructuring.

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { BarChart3 } from "../../components/icons";

import PartnerOverview from "./partner/PartnerOverview";

const NAV = [
  { label: "Overview", path: "/partner", icon: BarChart3 },
];

export default function PartnerDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout nav={NAV} />}>
        <Route index element={<PartnerOverview />} />
        <Route path="*" element={<Navigate to="/partner" replace />} />
      </Route>
    </Routes>
  );
}